import React from "react";
import { useTranslation } from "react-i18next";

const MobileDocumentsFileViewer: React.FC<{ url?: string }> = ({ url }) => {
    const fileExtension = url?.split(".").pop()?.toLowerCase();
    const { t } = useTranslation();

    console.log("extension", fileExtension);

    if (!url) {
        return <p>{t("NoFileAvailable")}</p>;
    }

    if (fileExtension === "pdf") {
        const googleDocsUrl = `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(url)}`;

        return (
            <iframe
                src={googleDocsUrl}
                style={{
                    width: "100%",
                    height: "calc(100% - 40px)",
                    border: "none",
                }}
                title="File Viewer - PDF"
            ></iframe>
        );
    } else if (["jpg", "jpeg", "png"].includes(fileExtension || "")) {
        return (
            <img
                src={url}
                alt="File Viewer"
                style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    display: "block",
                    margin: "auto",
                }}
            />
        );
    } else {
        return <p>{t("UnsupportedFileType")}</p>;
    }
};

export default MobileDocumentsFileViewer;
